import React, { Suspense } from 'react';
import { Route, Switch } from "react-router-dom";
import Dashboard from "../pages/Dashboard";

import { componentMapping } from './componentMapping';
import LogoutPage from '../pages/login/SGK/LogoutPage';
import { DialogProvider } from './useDialog';
import { DetailDialogProvider } from './useDetail';


const AppRoutes = ({ routers }) => {

    const renderDynamicRoutes = (items) => {
        return items.map((item, key) => {
            if (item.isGroup && item.items) {
                // Recursively call renderDynamicRoutes for nested groups
                return renderDynamicRoutes(item.items);
            }

            // Get component reference from componentMapping
            const Component = componentMapping[item.component];
            if (!Component) {
                console.warn(`Component ${item.component} not found in componentMapping.`);
                return null; // Optionally handle missing components
            }

            // Render Route with dynamically resolved component
            return (
                <Route exact path={item.path} key={key}>
                    <DialogProvider>
                        <DetailDialogProvider>
                            <Suspense fallback={<div>Loading...</div>}>
                                <Component title={item.title} isfilter={false} />
                            </Suspense>
                        </DetailDialogProvider>
                    </DialogProvider>
                </Route>
            );
        });
    };



    return (
        <div id="content" className="content expanded">
            <Switch>
                <Route exact path="/">

                </Route>
                <Route exact path="/logout">
                    <LogoutPage />
                </Route>
                {routers.length > 0 && renderDynamicRoutes(routers)}
            </Switch>
        </div>
    );
};

export default AppRoutes;
